import {createSelector} from '@reduxjs/toolkit';
import {RootState} from '../app/store';
import projectsApi from './projects.api';

export const selectProject = (projectId: string) =>
  createSelector(
    (state: RootState) => projectsApi.endpoints.projectsById.select(projectId)(state).data,
    project => project,
  );
